import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Helmet from 'react-helmet';
import moment from 'moment';
import localization from 'moment/locale/it';

import { primary_s26_l96 } from '../../shared/lib/colors';

import { loadStore } from '../../../redux/modules/store';
import { loadCategories } from '../../../redux/modules/categories';
import { loadTags } from '../../../redux/modules/tags';
import { loadCart } from '../../../redux/modules/cart';
import { loadUser } from '../../../redux/modules/user';
import connectDataFetchers from '../../shared/lib/connectDataFetchers.js';

import Header from '../../shared/Header/Header';
import Footer from '../../shared/Footer/Footer';

import '../../../styles/style.scss';
import '../../../styles/style.less';

moment.locale('it');

class App extends Component {
  state = {
    paddingBottom: 0,
  };

  componentDidMount() {
    this.props.loadUser();

    // Se MailChimp ha passato la variabile mc_cid
    // in querystring, la metto nel localStorage.
    // Verrà passata nell'header McCid di tutte
    // le chiamate ad API
    const mcCid = this.props.router.location.query.mc_cid;
    if (mcCid) {
      localStorage.setItem('mc_cid', mcCid);
    }

    // Se AWIN ha passato la variabile awc
    // in querystring, la metto nel localStorage.
    // Verrà passata nell'header AwCks di tutte
    // le chiamate ad API
    const awCks = this.props.router.location.query.awc;
    if (awCks) {
      localStorage.setItem('aw_cks', awCks);
    }

    // Check if we need to add padding bottom
    this._checkMobilePaddingBottom();
  }

  componentDidUpdate(oldProps) {
    if (this.props.location.pathname !== oldProps.location.pathname) {
      this._checkMobilePaddingBottom();
    }
  }

  _checkMobilePaddingBottom = () => {
    if (!this.props.isMobile) return;
    // TODO: inserire anche gli altri
    const divsToFind = ['add-to-cart-section-footer', 'total-buttons mobile'];
    // we get the divs by class name
    let divs = [];
    divsToFind.forEach(className => {
      const div = document.getElementsByClassName(className);
      if (div.length > 0) {
        divs = [...divs, ...div];
      }
    });
    // now we get the height of the last div
    let paddingBottom = 0;
    if (divs.length > 0) {
      const lastDiv = divs[divs.length - 1];
      const lastDivHeight = lastDiv.offsetHeight;
      paddingBottom = lastDivHeight;
    }
    this.setState({ paddingBottom });
  };

  renderBackgroundVersion = uiVariantBackground => {
    switch (uiVariantBackground) {
      case '1':
        return primary_s26_l96(this.props.primaryColor);
      case '2':
        return '#f6f6f6';
      case '3':
        return '#fff';
      default:
        return uiVariantBackground;
    }
  };

  render() {
    const isCheckout = this.props.router.isActive('checkout');

    const headerConfig = this.props.homePageConfiguration.find(
      item => item.moduleType === 'Header'
    );

    return (
      <div className={isCheckout ? 'is-checkout' : 'is-not-checkout'}>
        <Helmet
          titleTemplate={`%s | ${this.props.siteName} - Ecommerce Farmacia`}
        >
          <link rel="icon" type="image/x-icon" href={this.props.favicon} />
        </Helmet>

        <div
          className={`global-wrapper version-${
            headerConfig ? headerConfig.moduleVersion : 1
          }`}
          style={{ paddingBottom: this.state.paddingBottom }}
        >
          <Header isCheckout={isCheckout} />

          {this.props.children}

          <Footer isCheckout={isCheckout} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    isMobile: state.layout.isMobile,
    siteName: state.store.data.datiFarmacia.siteName,
    favicon: state.store.data.loghiTemplate.faviconImage,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    uiVariantBackground: state.store.data.uiVariants.background,
    homePageConfiguration: state.store.data.home.homePageConfiguration,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadCart: () => dispatch(loadCart()),
    loadUser: () => dispatch(loadUser()),

    dispatch,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(connectDataFetchers(withRouter(App), [loadCategories, loadTags, loadStore]))
);
